import axios from 'axios';
import routes from 'app/routes';

export default {
  sendMail: (values, onSuccess) => {
    axios
      .post(routes.api.slack.sendSetupMail, values)
      .then((_resp) => {
        onSuccess();
      });
  },
};
